import { get } from 'lodash';
import { RegionType } from '@wix/shoutout-email-model-v3';
import { defaultDividerName, defaultDividerRole, defaultTextColor, } from '../../utils/defaults';
import { toNormalizedHueSatBr, toRgbAsHex } from '../../utils/color';
import * as cssUtils from '../../utils/css-utils';
import { adjustImage } from '../../utils/adjust-image';
import { crossDeviceDividerMap, dividerWidthMap, dividerHeightMap, defaultHeight, defaultWidth, } from './divider-map';
var singleImageAdjustment = function (_a) {
    var dividerKey = _a.dividerKey;
    var height = dividerHeightMap[dividerKey];
    var width = dividerWidthMap[dividerKey];
    return function (_a) {
        var hue = _a.hue, sat = _a.sat, br = _a.br;
        return ({
            al: 'c',
            h: height || defaultHeight,
            q: 100,
            w: width || defaultWidth,
            // FYI: adding params in different order might cause different result;
            br: br,
            sat: sat,
            hue: hue,
        });
    };
};
export var getDividerSection = function (_a) {
    var region = _a.region, composerData = _a.composerData, css = _a.css;
    if (region.type !== RegionType.Divider) {
        throw Error('Divider must be passed');
    }
    var isDecorator = (get(region, 'data.role') || defaultDividerRole) === 'decorator';
    var defaultColorSetting = isDecorator
        ? 'so-global-divider2'
        : 'so-global-divider';
    var defaultDividerKeySetting = isDecorator
        ? 'defaultDecoratorName'
        : 'defaultDividerName';
    var color = get(region, 'data.styles.fill') ||
        get(css, defaultColorSetting + ".fill") ||
        defaultTextColor;
    var hueSatBr = toNormalizedHueSatBr(color);
    var dividerKey = get(region, 'data.shape') ||
        get(composerData, "styles.settings." + defaultDividerKeySetting) ||
        defaultDividerName;
    var dividerImage = crossDeviceDividerMap[dividerKey];
    var dividerType = region.data.role === 'decorator' ? 'divider--decorator' : 'divider--normal';
    var desktopAdjustmentModel = singleImageAdjustment({ dividerKey: dividerKey });
    var userOverrides = get(region, 'data.styles.region');
    var rules = [
        userOverrides,
        css["so-global-region-" + dividerType],
        css['so-global-region'],
    ];
    var mobileCssClass = cssUtils.getRegionMobileCssClass(rules, true);
    var margin = cssUtils.margin(rules);
    var padding = cssUtils.padding(rules);
    var htmlDividerStyles = getHtmlDividerStyles(dividerKey, color);
    if (htmlDividerStyles && htmlDividerStyles.width !== '100%') {
        // TODO: very strange code, need to doublecheck live.
        padding.left = 0;
        padding.right = 0;
    }
    return {
        cssClass: mobileCssClass,
        dividerImageDesktop: dividerImage &&
            adjustImage(dividerImage, desktopAdjustmentModel(hueSatBr)),
        htmlDividerStyles: htmlDividerStyles,
        dividerWidth: dividerWidthMap[dividerKey] || defaultWidth,
        dividerHeight: dividerHeightMap[dividerKey] || defaultHeight,
        outerPadding: margin,
        innerPadding: padding,
    };
};
function getHtmlDividerStyles(dividerKey, color) {
    var full = '100%';
    var short = '62px';
    var hexColor = toRgbAsHex(color);
    switch (dividerKey) {
        case 'divider1':
            return {
                border: "1px solid " + hexColor,
                width: full,
            };
        case 'divider5':
            return {
                border: "3px solid " + hexColor,
                width: full,
            };
        case 'divider6':
            return {
                border: "8px solid " + hexColor,
                width: full,
            };
        case 'divider9':
            return {
                border: "2px solid " + hexColor,
                width: short,
            };
        case 'divider10':
            return {
                border: "6px solid " + hexColor,
                width: short,
            };
        default:
            return null;
    }
}
//# sourceMappingURL=get-divider-section.js.map